import {MutationTree} from "vuex";
import {EventImplementationState, EventImplementation} from "./model";

const mutations: MutationTree<EventImplementationState> = {
  setEventImplementations(state, eventImplementations: EventImplementation[]) {
    state.eventImplementations = eventImplementations;
  },
  addEventImplementation(state, eventImplementation: EventImplementation) {
    state.eventImplementations.push(eventImplementation);
  },
  updateEventImplementation(state, eventImplementation: EventImplementation) {
    const c = state.eventImplementations.find(c => c.id === eventImplementation.id);
    if(c) {
      Object.assign(c, eventImplementation);
    }
  },
  deleteEventImplementation(state, id: string) {
    state.eventImplementations = state.eventImplementations.filter(eventImplementation => eventImplementation.id !== id);
  }
}

export default mutations;
